import React from 'react'
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import LineGradient from '../components/LineGradient';
import one from '../assets/clientproject/1.png'

export default function ClientWorks() {
    return (
        <div>
            <section id="experience" className=" pb-12">
                {/* HEADER AND IMAGE SECTION */}
                <div className="">
                    <motion.div
                        // className="md:w-1/3"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.5 }}
                        transition={{ duration: 0.5 }}
                        variants={{
                            hidden: { opacity: 0, x: -50 },
                            visible: { opacity: 1, x: 0 },
                        }}
                    >
                        <p className="font-playfair font-semibold text-4xl mb-5">
                            <span className="text-cyan-500">CLIENT WORKS</span>
                        </p>
                        <LineGradient width=" w-[100px]" />
                        <p className="mt-8 text-justify">
                            I am actively involved in various client projects, with a strong focus on React-based development due to my expertise in React. Below, I have highlighted some of the notable client projects I have worked on.
                        </p>
                        <section className='grid grid-cols-1 lg:grid-cols-4 py-5'>
                            <div className=' rounded-xl border-2'>
                                <img src={one} alt='img' className=' rounded-tl-xl rounded-tr-xl' />
                                <h1 className='text-white text-[20px] text-center my-2'>Portfolio </h1>
                                <button className=' bg-cyan-700 text-white text-[15px] py-1 w-full rounded-bl-xl rounded-br-xl'> <Link href='/https://rafidchowdhury00001.netlify.app/'>Live Site</Link></button>
                            </div>
                        </section>

                    </motion.div>

                </div >


            </section >
        </div >
    )
}
